<div class="search-filter-footer">
  <button role="button" class="search-filter-footer__clear" [ngClass]="{'hidden': activeItemsByKey === 0}" (click)="resetFilterByKey()">
    <span class="search-filter-footer__clear-title">Auswahl löschen</span>
    <span class="search-filter-footer__clear-number">{{activeItemsByKey}}</span>
  </button>


  <div class="search-filter-footer__save" (click)="onSaveClicked()" #saveButtonWrapper>
    <brt-button [show-loader]="isLoadingOnClose" [title]="getButtonLabel()" [color]="'river'"></brt-button>
  </div>


</div>
